import useWindowSize from "hooks/useWindowSize";
import { CnpHoldingCardItems } from "./CnpHoldingCardConstants";
import * as S from "./CnpHoldingCards.style";
import Carousel from "components/common/Carousel";

const Card = CnpHoldingCardItems.map(({ img, paragraph, link }) => (
  <S.CardCnpHolding>
    <S.ContentCardCnpHolding>
      <S.ImgCardCnpHolding>{img}</S.ImgCardCnpHolding>
      <S.ParagraphCardCnpHolding>{paragraph}</S.ParagraphCardCnpHolding>
    </S.ContentCardCnpHolding>
    <S.ButtonCardCnpHolding role="link" onClick={() => window.open(link)}>
      <S.TextButtonCardCnpHolding>Saiba mais</S.TextButtonCardCnpHolding>
    </S.ButtonCardCnpHolding>
  </S.CardCnpHolding>
));

const CnpHoldingCards = () => {
  const { width } = useWindowSize();
  return (
    <S.SectionCnpHolding>
      <S.TitleCnpHolding>Nossas empresas e instituto social</S.TitleCnpHolding>
      <S.ContainerCardCnpHolding>
        {width > 768 ? Card : <Carousel children={Card} />}
      </S.ContainerCardCnpHolding>
    </S.SectionCnpHolding>
  );
};

export default CnpHoldingCards;
